import { useDisclosure } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { createContext, FC, ReactNode, useContext, useEffect } from "react";

type SideMenuOpen = {
  sideMenuOpen: boolean;
  onSideMenuOpen(): void;
  onSideMenuClose(): void;
};

const context = createContext<SideMenuOpen>({
  sideMenuOpen: false,
  onSideMenuOpen() {},
  onSideMenuClose() {},
});

const { Provider } = context;

export const SideMenuOpenProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const { pathname } = useRouter();

  // 画面遷移時にサイドメニューを閉じる
  useEffect(() => {
    onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Provider value={{ sideMenuOpen: isOpen, onSideMenuOpen: onOpen, onSideMenuClose: onClose }}>
      {children}
    </Provider>
  );
};

export const useSideMenuOpen = () => {
  const { sideMenuOpen, onSideMenuOpen, onSideMenuClose } = useContext(context);

  return {
    sideMenuOpen,
    onSideMenuOpen,
    onSideMenuClose,
  };
};
